import Configuration from '@/agilis/util/Configuration'
import jsonLogic from '@/plugins/jsonLogic'
import { mapGetters } from 'vuex'
import trackerDataTableItemActions from '@/applications/scrum/components/TrackerDataTable/TrackerDataTableItemActions/TrackerDataTableItemActions'

export default {
  name: 'TrackerDataTableItemActionsMobile',
  inject: ['provideJlAssertionContext', 'provideTrackerDTO'],
  mixins: [trackerDataTableItemActions],
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      selectedContext: 'contextStore/selectedContext',
      userId: 'userDataStore/userId',
      trackerStateMachine: 'contextStore/trackerStateMachine'
    }),
    stateLabel () {
      return this.trackerStateMachine.states.find(element => element.id === this.trackerDTOComputed?.state)?.label || ''
    },
    trackerDTOComputed () {
      return this.provideTrackerDTO
    },
    jlAssertionContextComputed () {
      return this.provideJlAssertionContext
    },
    jlContextComputed () {
      return Object.assign(
        {},
        this.jlAssertionContextComputed,
        this.trackerDTOComputed
      )
    },
    actionArray () {
      return Configuration.auth.getEventsFromState(this.provideTrackerDTO).map(a => {
        const validationLogic = a.validationLogic && a.validationLogic.jsonLogic

        // see https://jsonlogic.com
        let validationOutput
        try {
          validationOutput = validationLogic ? jsonLogic.apply(validationLogic, this.jlContextComputed) : true
        } catch (e) { // catch unsupportd logics
          console.log('Unsupported json-logic', e)
          validationOutput = false
        }
        const invalid = validationOutput !== true
        return Object.assign({}, a, {
          invalid,
          errorMessage: invalid ? (
            typeof validationOutput === 'string' ? this.$t(validationOutput) : this.$t('actionValidationKo')
          ) : null
        })
      })
    }
  },
  methods: {
    actionPopupData (formValues = {}) {
      const trackerTypeName = this.$t(this.trackerType.name)
      return {
        trackerTypeName,
        ...Object.assign({}, this.trackerDTOComputed, formValues)
      }
    },
    async handleActionClick (actionId) {
      const eventConfig = Configuration.state.getTrackerEventsMap(this.provideTrackerDTO)[actionId]
      const dataTable = eventConfig?.userPopup?.dataTable
      if (dataTable) {
        dataTable.fields = this.formFields(dataTable.columns)
      }

      const userConfirmPromise = eventConfig?.userPopup ? this.notifyUserConfirm({
        title: eventConfig?.label, // default title: the event label (it can be overwitten by eventConfig.userPopup.title)
        ...eventConfig.userPopup,
        form: dataTable,
        data: this.actionPopupData(dataTable?.formValues)
      }) : Promise.resolve(true)

      const userConfirmResponse = await userConfirmPromise

      if (userConfirmResponse) {
        const eventPayload = userConfirmResponse !== true ? userConfirmResponse : {}
        const url = this.$axios.agilisUrlTrackerAction(
          this.provideTrackerDTO.applicationId, this.provideTrackerDTO.trackerTypeId, this.provideTrackerDTO.id, actionId)
        try {
          this.loading = true
          const response = await this.$axios.post(url, eventPayload, this.$axios.agilisRequestConfig(url))
          const eventName = this.$t(Configuration.state.getTrackerEventsMap(this.provideTrackerDTO)[actionId].label)
          const stateName = this.$t(Configuration.state.getTrackerStatesMap(this.provideTrackerDTO)[response.data.state].label)
          const message = response.data.transitionMessage
            ? this.$t('message.actionSuccess', { action: eventName, state: stateName }).concat('\n\n' + response.data.transitionMessage)
            : this.$t('message.actionSuccess', { action: eventName, state: stateName })
          this.$store.commit('mobileDataTableStore/setReloadAll', true)
          this.loading = false
          this.notifyMessage(message)
        } catch (error) {
          this.loading = false
          this.notifyError(error)
          this.stopLoader({ id: 'change-tracker-state' })
        }
      }
    },
    userCanAccessFeature (featureId) {
      return Configuration.auth.userCanAccessFeature(
        this.selectedContext, featureId, null, this.provideTrackerDTO, this.userId)
    },
    disabledMessage (actionArray) {
      return actionArray.find(action => action.errorMessage)?.errorMessage
    }
  }
}
